/**
 * App Theme Configuration
 *
 * Edit this file to change colors, font, and border radius.
 * The ThemeProvider applies these values as CSS variables on startup.
 *
 * Colors use HSL format: "hue saturation% lightness%"
 *
 * For preset inspiration, see src/lib/themes.ts — copy any preset's
 * values here and customize as needed.
 */

// ── Font presets (uncomment one, or add your own Google Fonts URL) ──
// Geometric sans — tech, clean, modern
// const font = { url: 'https://fonts.googleapis.com/css2?family=Inter:wght@400..700&display=swap', family: "'Inter', sans-serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400..700&display=swap', family: "'Space Grotesk', sans-serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Sora:wght@400..700&display=swap', family: "'Sora', sans-serif" };
// Humanist sans — friendly, approachable
// const font = { url: 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400..700&display=swap', family: "'DM Sans', sans-serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400..700&display=swap', family: "'Plus Jakarta Sans', sans-serif" };
// Serif — luxury, editorial, premium
// const font = { url: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400..900&display=swap', family: "'Playfair Display', serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400..700&display=swap', family: "'Cormorant Garamond', serif" };
// Mono — developer, hacker, terminal
// const font = { url: 'https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400..700&display=swap', family: "'JetBrains Mono', monospace" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&display=swap', family: "'Space Mono', monospace" };
// Display — bold, creative, expressive
// const font = { url: 'https://fonts.googleapis.com/css2?family=Unbounded:wght@400..700&display=swap', family: "'Unbounded', sans-serif" };
// const font = { url: 'https://fonts.googleapis.com/css2?family=Syne:wght@400..700&display=swap', family: "'Syne', sans-serif" };

// Active font — Manrope for body text. Sora (loaded alongside) is used for
// headings via the `.font-heading` utility class defined in src/styles/base.css.
const font = {
  url: 'https://fonts.googleapis.com/css2?family=Sora:wght@400..800&family=Manrope:wght@400..800&display=swap',
  family: "'Manrope', sans-serif",
};

// Creve design system — warm paper background, coral primary accent, amber
// reserved for status/premium accents only. See src/styles/base.css for the
// `.font-heading` (Sora) utility used on all headings.
export const theme = {
  colors: {
    background: '45 29% 97%', // paper #FAF9F6
    foreground: '40 6% 10%', // ink #1C1B19
    card: '0 0% 100%', // white cards on paper bg
    'card-foreground': '40 6% 10%',
    popover: '0 0% 100%',
    'popover-foreground': '40 6% 10%',
    primary: '7 86% 58%', // coral #F04E37
    'primary-foreground': '0 0% 100%',
    secondary: '10 82% 96%', // coral-light #FDEEEB
    'secondary-foreground': '7 69% 50%', // coral-dark #D63C27
    muted: '45 20% 93%',
    'muted-foreground': '40 8% 42%',
    accent: '34 69% 61%', // amber #E0A458 — status/premium accent only
    'accent-foreground': '30 60% 25%',
    destructive: '0 72% 51%',
    'destructive-foreground': '0 0% 100%',
    border: '42 16% 88%', // line #E5E2DB
    input: '42 16% 88%',
    ring: '7 86% 58%',
    link: '7 69% 50%',
    'link-hover': '7 86% 58%',
    button: '7 86% 58%',
    'button-foreground': '0 0% 100%',
    'button-border': '7 86% 58%',
    'button-hover': '7 69% 50%',
    'button-hover-foreground': '0 0% 100%',
    'button-hover-border': '7 69% 50%',
    'button-ring': '7 86% 58%',
    'chart-1': '7 86% 58%',
    'chart-2': '34 69% 61%',
    'chart-3': '160 40% 45%',
    'chart-4': '210 40% 50%',
    'chart-5': '280 35% 55%',
    'sidebar-background': '45 29% 97%',
    'sidebar-foreground': '40 6% 10%',
    'sidebar-primary': '7 86% 58%',
    'sidebar-primary-foreground': '0 0% 100%',
    'sidebar-accent': '10 82% 96%',
    'sidebar-accent-foreground': '7 69% 50%',
    'sidebar-border': '42 16% 88%',
    'sidebar-ring': '7 86% 58%',
  },
  font,
  radius: '1rem',
};
